import { Action } from 'redux';

export const SHOW_PRELOADER = 'show-preloader/SHOW_PRELOADER';
export const HIDE_PRELOADER = 'hide-preloader/HIDE_PRELOADER';
export const IS_LOADING_YN = 'pre-loader/IS_LOADING_YN';
// export const IS_LOADING_YN_COMPLETE = "pre-loader/IS_LOADING_YN_COMPLETE";
export const SHOW_MESSAGE_ALERT_MODAL = 'pre-loader/SHOW_MESSAGE_ALERT_MODAL';
export const HIDE_MESSAGE_ALERT_MODAL = 'pre-loader/HIDE_MESSAGE_ALERT_MODAL';
export const SHOW_PAGE_LOADING_YN = 'pre-loader/SHOW_PAGE_LADING_YN';
export const HIDE_PAGE_LOADING_YN = 'pre-loader/HIDE_PAGE_LOADING_YN';

export const showPageLoading = () => {
  return {
    type: SHOW_PAGE_LOADING_YN,
  };
};
export const hidePageLoading = () => {
  return {
    type: HIDE_PAGE_LOADING_YN,
  };
};
export const showPreLoader = () => {
  return {
    type: SHOW_PRELOADER,
  };
};

export const hidePreLoader = () => {
  return {
    type: HIDE_PRELOADER,
  };
};
export const isLoadingYN = (data: boolean) => {
  return {
    type: IS_LOADING_YN,
    payload: data,
  };
};
// export const isLoadingYNComplete = (data: boolean) => {
//   return {
//     type: IS_LOADING_YN_COMPLETE,
//     payload: data
//   }
// }
export const showMessageAlertModal = (data: MessageAlertModal) => {
  return {
    type: SHOW_MESSAGE_ALERT_MODAL,
    payload: data,
  };
};
export const hideMessageAlertModal = () => {
  return {
    type: HIDE_MESSAGE_ALERT_MODAL,
  };
};

export interface ShowPreLoaderAction extends Action<typeof SHOW_PRELOADER> {}
export interface HidePreLoaderAction extends Action<typeof HIDE_PRELOADER> {}
export interface IsLoadingYNAction extends Action<typeof IS_LOADING_YN> {
  payload: boolean;
}
export interface ShowMesageAlertAction extends Action<typeof SHOW_MESSAGE_ALERT_MODAL> {
  payload: MessageAlertModal;
}
export interface HideMesageAlertAction extends Action<typeof HIDE_MESSAGE_ALERT_MODAL> {}
export interface ShowPageLoadingAction extends Action<typeof SHOW_PAGE_LOADING_YN> {}
export interface HidePageLoadingAction extends Action<typeof HIDE_PAGE_LOADING_YN> {}

export type PreLoaderAction =
  | ShowPreLoaderAction
  | HidePreLoaderAction
  | IsLoadingYNAction
  | ShowMesageAlertAction
  | HideMesageAlertAction
  | ShowPageLoadingAction
  | HidePageLoadingAction;
